import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FontAwesome from 'react-fontawesome'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import {
	StyledContainerInput,
	StyledLabel,
	StyledInputPure,
	StyledInput,
} from '../../../components/form-components/light-select-search-bar-async/styled-input.style'

class AffiliateCodeComponent extends React.Component {
	constructor(props) {
		super(props)
		this.handleChangeAffiliateCode = this.handleChangeAffiliateCode.bind(this)
	}

	handleChangeAffiliateCode(event) {
		const { value } = event.target
		this.props.setAffiliateCode(value)
	}

	render() {
		return (
			<StyledContainerInput>
				<StyledLabel>Digite o código de afiliado</StyledLabel>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
					}}>
					<StyledInputPure
						label="Digite o código de afiliado"
						type="text"
						maxLength={50}
						onChange={this.handleChangeAffiliateCode}
						values={this.props.codigoAfiliado}
					/>
					<div
						style={{
							marginLeft: '10px',
						}}>
						<FontAwesome
							name="info-circle"
							data-for="codigoAfiliado-tooltip"
							data-tip="true"
							data-multiline="true"
							data-html="true"
						/>
						<span>
							{''} Insira um código de afiliado (
							<strong>opcional</strong>). Este código não oferece
							desconto.
						</span>
					</div>
				</div>
			</StyledContainerInput>
		)
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			setAffiliateCode: TicketSaleCreators.setAffiliateCode,
		},
		dispatch
	)

const mapStateToProps = (store) => ({
	affiliateCode: store.ticketSale.affiliateCode,
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AffiliateCodeComponent)
